const messages = {
	es: {
		translations: {
			signup: {
				title: "Registro",
				toasts: {
					success:
						"¡El usuario ha sido creado satisfactoriamente! ¡Ahora inicia sesión!",
					fail: "Error creando el usuario. Verifica la data reportada.",
				},
				form: {
					name: "Nombre",
					email: "Correo Electrónico",
					password: "Contraseña",
				},
				buttons: {
					submit: "Regístrate",
					login: "¿Ya tienes una cuenta? ¡Inicia sesión!",
				},
			},
			login: {
				title: "Inicio de Sesión",
				form: {
					email: "Correo Electrónico",
					password: "Contraseña",
				},
				buttons: {
					submit: "Ingresa",
					register: "¿No tienes cuenta? ¡Regístrate!",
				},
			},
			auth: {
				toasts: {
					sessionExpired: "Tu sesión ha expirado. Inicia sesión nuevamente.",
					sessionReplaced: "Tu cuenta fue accedida en otra computadora y esta sesión se cerró. Si no fuiste tú, cambia tu contraseña.",
					invalidCredentials: "Credenciales inválidas. Verifica tus datos e inténtalo de nuevo.",
					accessDenied: "Acceso denegado. Contacta al administrador del sistema.",
					networkError: "No se pudo conectar con el servidor. Verifica tu conexión e inténtalo de nuevo.",
					error: "No fue posible iniciar sesión. Inténtalo de nuevo en unos instantes.",
				},
			},
			dashboard: {
				charts: {
					perDay: {
						title: "Tickets hoy: ",
					},
				},
			},
			connections: {
				title: "Conexiones",
				toasts: {
					deleted:
						"¡La conexión de WhatsApp ha sido borrada satisfactoriamente!",
				},
				confirmationModal: {
					deleteTitle: "Borrar",
					deleteMessage: "¿Estás seguro? Este proceso no puede ser revertido.",
					disconnectTitle: "Desconectar",
					disconnectMessage: "Estás seguro? Deberá volver a leer el código QR",
				},
				buttons: {
					add: "Agrega WhatsApp",
					disconnect: "Desconectar",
					tryAgain: "Inténtalo de nuevo",
					qrcode: "QR CODE",
					newQr: "Nuevo QR CODE",
					connecting: "Conectando",
				},
				toolTips: {
					disconnected: {
						title: "No se pudo iniciar la sesión de WhatsApp",
						content:
							"Asegúrese de que su teléfono celular esté conectado a Internet y vuelva a intentarlo o solicite un nuevo código QR",
					},
					qrcode: {
						title: "Esperando la lectura del código QR",
						content:
							"Haga clic en el botón 'CÓDIGO QR' y lea el Código QR con su teléfono celular para iniciar la sesión",
					},
					connected: {
						title: "Conexión establecida",
					},
					timeout: {
						title: "Se perdió la conexión con el teléfono celular",
						content:
							"Asegúrese de que su teléfono celular esté conectado a Internet y que WhatsApp esté abierto, o haga clic en el botón 'Desconectar' para obtener un nuevo código QR",
					},
				},
				table: {
					name: "Nombre",
					status: "Estado",
					lastUpdate: "Última Actualización",
					default: "Por Defecto",
					actions: "Acciones",
					session: "Sesión",
				},
			},
			whatsappModal: {
				title: {
					add: "Agrega WhatsApp",
					edit: "Edita WhatsApp",
				},
				form: {
					name: "Nombre",
					default: "Por Defecto",
				},
				buttons: {
					okAdd: "Agregar",
					okEdit: "Guardar",
					cancel: "Cancelar",
				},
				success: "WhatsApp guardado satisfactoriamente.",
			},
			qrCode: {
				message: "Lée el código QR para empezar la sesión.",
			},
			contacts: {
				title: "Contactos",
				toasts: {
					deleted: "¡Contacto borrado satisfactoriamente!",
				},
				searchPlaceholder: "Buscar...",
				confirmationModal: {
					deleteTitle: "Borrar",
					importTitlte: "Importar contactos",
					deleteMessage:
						"¿Estás seguro que deseas borrar este contacto? Todos los tickets relacionados se perderán.",
					importMessage:
						"¿Quieres importar todos los contactos desde tu teléfono?",
				},
				buttons: {
					import: "Importar Contactos",
					add: "Agregar Contacto",
				},
				table: {
					name: "Nombre",
					whatsapp: "WhatsApp",
					email: "Correo Electrónico",
					actions: "Acciones",
				},
			},
			contactModal: {
				title: {
					add: "Agregar contacto",
					edit: "Editar contacto",
				},
				form: {
					mainInfo: "Detalles del contacto",
					extraInfo: "Información adicional",
					name: "Nombre",
					number: "Número de Whatsapp",
					email: "Correo Electrónico",
					extraName: "Nombre del Campo",
					extraValue: "Valor",
				},
				buttons: {
					addExtraInfo: "Agregar información",
					okAdd: "Agregar",
					okEdit: "Guardar",
					cancel: "Cancelar",
				},
				success: "Contacto guardado satisfactoriamente.",
			},
			queueModal: {
				title: {
					add: "Agregar cola",
					edit: "Editar cola",
				},
				form: {
					name: "Nombre",
					color: "Color",
					greetingMessage: "Mensaje de saludo",
				},
				buttons: {
					okAdd: "Añadir",
					okEdit: "Ahorrar",
					cancel: "Cancelar",
					attach: "Anexar Arquivo",
				},
			},
			userModal: {
				title: {
					add: "Agregar usuario",
					edit: "Editar usuario",
				},
				form: {
					name: "Nombre",
					email: "Correo Electrónico",
					password: "Contraseña",
					profile: "Perfil",
				},
				buttons: {
					okAdd: "Agregar",
					okEdit: "Guardar",
					cancel: "Cancelar",
				},
				success: "Usuario guardado satisfactoriamente.",
			},
			chat: {
				noTicketMessage: "Selecciona un ticket para empezar a chatear.",
			},
			ticketsManager: {
				buttons: {
					newTicket: "Nuevo",
				},
			},
			ticketsQueueSelect: {
				placeholder: "Linhas",
			},
			tickets: {
				toasts: {
					deleted: "El ticket en el que estabas ha sido borrado.",
				},
				notification: {
					message: "Mensaje de",
				},
				tabs: {
					open: { title: "Bandeja" },
					closed: { title: "Resueltos" },
					search: { title: "Buscar" },
				},
				search: {
					placeholder: "Buscar tickets y mensajes.",
				},
				buttons: {
					showAll: "Todos",
				},
			},
			transferTicketModal: {
				title: "Transferir Ticket",
				fieldLabel: "Escriba para buscar usuarios",
				noOptions: "No se encontraron usuarios con ese nombre",
				buttons: {
					ok: "Transferir",
					cancel: "Cancelar",
				},
			},
			ticketsList: {
				pendingHeader: "Cola",
				assignedHeader: "Trabajando en",
				noTicketsTitle: "¡Nada acá!",
				noTicketsMessage:
					"No se encontraron tickets con este estado o término de búsqueda",
				buttons: {
					accept: "Acceptar",
				},
			},
			newTicketModal: {
				title: "Crear Ticket",
				fieldLabel: "Escribe para buscar un contacto",
				add: "Añadir",
				buttons: {
					ok: "Guardar",
					cancel: "Cancelar",
				},
			},
			accountMenu: {
				trigger: "Opciones de la cuenta",
				admin: "Admin",
				user: "Agente",
				profile: "Mi perfil",
				profileHint: "Nombre, correo y contraseña",
				appearance: "Apariencia",
				light: "Claro",
				dark: "Oscuro",
				system: "Sistema",
				sounds: "Sonidos",
				volume: "Volumen de los avisos",
				mute: "Silenciar",
				unmute: "Activar sonido",
				test: "Probar",
				tickets: "Atenciones",
				chat: "Chat interno",
				suggestion: "Sugerir mejora",
				logout: "Cerrar sesión",
				logoutTitle: "¿Cerrar sesión en Message Express?",
				logoutText: "Dejas de recibir atenciones en este navegador y apareces desconectado para el equipo.",
				cancel: "Cancelar",
				online: "En línea",
				away: "Ausente",
				goAway: "Marcar ausente",
				goOnline: "Marcar en línea",
				awayHint: "El equipo te ve como ausente. Sigues recibiendo avisos.",
			},
			mainDrawer: {
				listItems: {
					dashboard: "Dashboard",
					connections: "Conexiones",
					tickets: "Tickets",
					contacts: "Contactos",
					queues: "Linhas",
					administration: "Administración",
					users: "Usuarios",
					settings: "Configuración",
				},
				appBar: {
					user: {
						profile: "Perfil",
						logout: "Cerrar Sesión",
					},
				},
			},
			notifications: {
				noTickets: "Sin notificaciones.",
			},
			queues: {
				title: "Linhas",
				table: {
					name: "Nombre",
					color: "Color",
					greeting: "Mensaje de saludo",
					actions: "Comportamiento",
				},
				buttons: {
					add: "Agregar cola",
				},
				confirmationModal: {
					deleteTitle: "Eliminar",
					deleteMessage:
						"¿Estás seguro? ¡Esta acción no se puede revertir! Los tickets en esa cola seguirán existiendo, pero ya no tendrán ninguna cola asignada.",
				},
			},
			queueSelect: {
				inputLabel: "Linhas",
			},
			users: {
				title: "Usuarios",
				table: {
					name: "Nombre",
					email: "Correo Electrónico",
					profile: "Perfil",
					actions: "Acciones",
				},
				buttons: {
					add: "Agregar usuario",
				},
				toasts: {
					deleted: "Usuario borrado satisfactoriamente.",
				},
				confirmationModal: {
					deleteTitle: "Borrar",
					deleteMessage:
						"Toda la información del usuario se perderá. Los tickets abiertos de los usuarios se moverán a la cola.",
				},
			},
			settings: {
				success: "Configuración guardada satisfactoriamente.",
				title: "Configuración",
				settings: {
					userCreation: {
						name: "Creación de usuarios",
						options: {
							enabled: "Habilitado",
							disabled: "Deshabilitado",
						},
					},
				},
			},
			messagesList: {
				header: {
					assignedTo: "Asignado a:",
					buttons: {
						return: "Devolver",
						resolve: "Resolver",
						reopen: "Reabrir",
						accept: "Aceptar",
					},
				},
			},
			messagesInput: {
				placeholderOpen: "Escribe un mensaje",
				placeholderClosed:
					"Vuelva a abrir o acepte este ticket para enviar un mensaje.",
				signMessage: "Firmar",
			},
			contactDrawer: {
				header: "Detalles del contacto",
				buttons: {
					edit: "Editar contacto",
				},
				extraInfo: "Otra información",
			},
			ticketOptionsMenu: {
				delete: "Borrar",
				transfer: "Transferir",
				confirmationModal: {
					title: "¿Borrar ticket #",
					titleFrom: "del contacto ",
					message:
						"¡Atención! Todos los mensajes Todos los mensajes relacionados con el ticket se perderán.",
				},
				buttons: {
					delete: "Borrar",
					cancel: "Cancelar",
				},
			},
			confirmationModal: {
				buttons: {
					confirm: "Ok",
					cancel: "Cancelar",
				},
			},
			messageOptionsMenu: {
				delete: "Borrar",
				reply: "Responder",
				confirmationModal: {
					title: "¿Borrar mensaje?",
					message: "Esta acción no puede ser revertida.",
				},
			},
			backendErrors: {
				ERR_COMPANY_INVALID_NAME: "Nombre de empresa inválido.",
				ERR_EMAIL_ALREADY_EXISTS: "Este correo electrónico ya está en uso.",
				ERR_INVALID_EMAIL: "Correo electrónico inválido.",
				ERR_INVALID_PHONE: "Teléfono inválido. Incluya el código de área.",
				ERR_PHONE_ALREADY_EXISTS: "Este teléfono ya está registrado. Inicie sesión o contacte al soporte.",
				ERR_PASSWORD_TOO_WEAK:
					"La contraseña debe tener al menos 6 caracteres.",
				ERR_INVALID_PLAN: "Plan seleccionado inválido.",
				ERR_COMPANY_DISABLED: "Esta cuenta está desactivada. Contacte al soporte.",
				ERR_CANNOT_DELETE_OWN_COMPANY: "No es posible eliminar su propia empresa.",
				ERR_COMPANY_HAS_CROSS_REFERENCES: "Eliminación bloqueada: hay datos de otra empresa vinculados a esta. Revise el informe de eliminación.",
				ERR_TOO_MANY_REQUESTS: "Demasiados intentos. Espere un momento e intente de nuevo.",
				ERR_SUGGESTION_INVALID_FILE: "La captura debe ser una imagen.",
				ERR_SUGGESTION_FILE_TOO_LARGE: "La captura debe tener como máximo 5 MB.",
				ERR_CHAT_FILE_TOO_LARGE: "El archivo debe tener como máximo 20 MB.",
				ERR_CHAT_INVALID_FILE: "Archivo inválido.",
				ERR_CHAT_EMPTY_MESSAGE: "Escribe un mensaje o adjunta un archivo.",
				ERR_CHAT_TICKET_NOT_FOUND: "Atención no encontrada.",
				ERR_NO_CHAT_FOUND: "Conversación no encontrada.",
				ERR_NO_CHAT_MEDIA_FOUND: "Adjunto no encontrado.",
				ERR_SUGGESTION_INVALID_STATUS: "Estado de sugerencia inválido.",
				ERR_NO_SUGGESTION_FOUND: "Sugerencia no encontrada.",
				ERR_LICENSE_EXPIRED:
					"Su licencia ha expirado. Acceda a Finanzas para regularizar el pago y reactivar el sistema.",
				ERR_APPOINTMENT_NOT_FOUND: "Cita no encontrada.",
				ERR_INVALID_APPOINTMENT_STATUS: "Estado de cita inválido.",
				ERR_INVALID_APPOINTMENT_STATUS_TRANSITION:
					"Este cambio de estado no está permitido. Las citas concluidas, con ausencia o canceladas no pueden revertirse.",
				ERR_SLOT_NOT_AVAILABLE: "Este horario ya no está disponible.",
				ERR_SERVICE_INVALID_USERS: "Uno o más profesionales seleccionados no pertenecen a esta empresa.",
				ERR_LOGO_INVALID_TYPE: "Formato inválido. Use PNG, JPG o WEBP.",
				ERR_LOGO_TOO_LARGE: "Imagen demasiado grande. Máximo 2 MB.",
				ERR_INVALID_SLUG: "Enlace inválido. Use de 3 a 40 caracteres: letras, números y guiones.",
				ERR_SLUG_ALREADY_IN_USE: "Este enlace ya está en uso por otra empresa.",
				ERR_TRANSACTION_NOT_FOUND: "Movimiento financiero no encontrado.",
				ERR_INVALID_TRANSACTION_STATUS_TRANSITION:
					"Este cambio de estado no está permitido. Un movimiento pagado no vuelve a pendiente, y un movimiento cancelado no puede reabrirse.",
				ERR_NO_OTHER_WHATSAPP:
					"Debe haber al menos una conexión de WhatsApp predeterminada.",
				ERR_NO_DEF_WAPP_FOUND:
					"No se encontró WhatsApp predeterminado. Verifique la página de conexiones.",
				ERR_WAPP_NOT_INITIALIZED:
					"Esta sesión de WhatsApp no ​​está inicializada. Verifique la página de conexiones.",
				ERR_WAPP_CHECK_CONTACT:
					"No se pudo verificar el contacto de WhatsApp. Verifique la página de conexiones.",
				ERR_WAPP_INVALID_CONTACT: "Este no es un número de whatsapp válido.",
				ERR_WAPP_DOWNLOAD_MEDIA:
					"No se pudieron descargar los medios de WhatsApp. Verifique la página de conexiones.",
				ERR_INVALID_CREDENTIALS: "Error de autenticación. Vuelva a intentarlo.",
				ERR_SENDING_WAPP_MSG:
					"Error al enviar el mensaje de WhatsApp. Verifique la página de conexiones.",
				ERR_DELETE_WAPP_MSG: "No se pudo borrar el mensaje de WhatsApp.",
				ERR_OTHER_OPEN_TICKET: "Ya hay un ticket abierto para este contacto.",
				ERR_SESSION_EXPIRED: "Sesión caducada. Inicie sesión.",
				ERR_USER_CREATION_DISABLED:
					"La creación de usuarios fue deshabilitada por el administrador.",
				ERR_NO_PERMISSION: "No tienes permiso para acceder a este recurso.",
				ERR_NO_TAG_FOUND: "No se encontró ninguna etiqueta con este ID.",
				ERR_NO_CAMPAIGN_FOUND: "Campaña no encontrada.",
				ERR_PLAN_FEATURE_DISABLED: "Este recurso no está incluido en tu plan.",
				ERR_NO_COMPANY_FOUND: "Empresa no encontrada.",
				ERR_NO_TAGS_TO_ORDER: "No se envió ninguna etiqueta del Kanban para ordenar.",
				ERR_INVALID_TAG_ORDER: "El orden enviado para las columnas del Kanban no es válido.",
				ERR_DUPLICATED_CONTACT: "Ya existe un contacto con este número.",
				ERR_NO_SETTING_FOUND:
					"No se encontró ninguna configuración con este ID.",
				ERR_NO_CONTACT_FOUND: "No se encontró ningún contacto con este ID.",
				ERR_INVALID_DATE: "Fecha inválida.",
				ERR_CONTACT_FIELDS_INVALID: "Lista de campos inválida.",
				ERR_CONTACT_FIELDS_TOO_MANY: "Máximo de 30 campos.",
				ERR_CONTACT_FIELD_NAME_INVALID: "Cada campo necesita un nombre (hasta 100 caracteres).",
				ERR_CONTACT_FIELD_DUPLICATED: "Hay dos campos con el mismo nombre.",
				ERR_NO_TICKET_FOUND: "No se encontró ningún ticket con este ID.",
				ERR_NO_USER_FOUND: "No se encontró ningún usuario con este ID.",
				ERR_NO_WAPP_FOUND: "No se encontró WhatsApp con este ID.",
				ERR_CREATING_MESSAGE: "Error al crear el mensaje en la base de datos.",
				ERR_CREATING_TICKET: "Error al crear el ticket en la base de datos.",
				ERR_FETCH_WAPP_MSG:
					"Error al obtener el mensaje en WhtasApp, tal vez sea demasiado antiguo.",
				ERR_QUEUE_COLOR_ALREADY_EXISTS:
					"Este color ya está en uso, elija otro.",
				ERR_WAPP_GREETING_REQUIRED:
					"El mensaje de saludo es obligatorio cuando hay más de una cola.",
			},
		},
	},
};

export { messages };
